export default "__VITE_ASSET__By2buS3U__"